<template>
  <hic-index-page title="系统配置" hide-footer>
    <template slot="buttons">
      <el-button class="left-pad" type="danger" @click="create" size="small" icon="el-icon-plus">新建配置</el-button>
      <small class="info left-pad">请勿随意新建，若配置未使用追加也没有意义！</small>
    </template>
    <el-container class="f-h">
      <el-main>
        <el-row class="main-table">
          <el-empty v-if="!mySys || !mySys.length" description="没有子系统！请联系平台管理员。"></el-empty>
          <el-empty v-else-if="!model.settings || !model.settings.length" description="不需要配置！"></el-empty>
          <el-col style="padding: 0 2rem" align="left">
            <el-form ref="form" :model="model" :disabled="!permission.masterdata_setting_edit" :inline="apply != 'auth'">
              <el-form-item v-for="(item, index) in model.settings" :label="item.name" :key="item.code" :prop="`settings.${index}.value`" align="left" :rules="item.optRule" size="small" :class="item.id ? 'box' : 'master'">
                <el-row type="flex" align="middle">
                  <el-button v-if="item.id" type="text" icon="el-icon-close" size="mini" @click="del(item)" class="right-pad" :title="item.code" />
                  <el-input v-if="!item.optType || item.optType == 'string'" v-model="item.value" @change="save(item)" placeholder="请输入"></el-input>
                  <el-input v-else-if="item.optType == 'number'" type="number" v-model.number="item.value" @change="save(item)" placeholder="请输入"></el-input>
                  <el-input v-else-if="item.optType == 'text'" type="textarea" :rows="6" v-model="item.value" @change="save(item)" placeholder="请输入" style="min-width: 16rem"></el-input>
                  <el-switch v-else-if="item.optType == 'bool'" @change="save(item)" v-model="item.value" active-color="#13ce66" active-text="是" active-value="true" inactive-color="#ff4949" inactive-text="否" inactive-value="false" style="margin: 5px 0"></el-switch>
                  <el-select v-else-if="item.optType == 'dict'" v-model="item.value" placeholder="请选择" :clearable="!item.optRule || !item.optRule[0].required" style="width: 100%" @change="save(item)">
                    <el-option v-for="i in item.optDict" :key="i.code" :label="i.text" :value="i.code"></el-option>
                  </el-select>
                  <el-date-picker v-else-if="item.optType == 'date'" v-model="item.value" type="date" placeholder="请选择" @change="save(item)"></el-date-picker>
                  <el-time-picker v-else-if="item.optType == 'time'" v-model="item.value" placeholder="请选择"></el-time-picker>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
      <el-aside width="auto">
        <br />
        <el-tabs v-model="apply" @tab-click="changeApply" size="mini" tab-position="right">
          <el-tab-pane v-for="sys in mySys" :label="sys.name" :name="sys.code" :key="sys.code"></el-tab-pane>
        </el-tabs>
      </el-aside>
    </el-container>
    <Editor v-model="entity" :visible.sync="showCreator" @ok="changeApply" />
  </hic-index-page>
</template>
<script>
  import api from "./api.js";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  // import cfg from "@/common/cfg"
  export default {
    components: {
      Editor: () => import("./editor"),
    },
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_setting_query) {
        next({
          name: "err",
          params: {
            err: cfg.errs.NeedPromission,
          },
        });
      } else {
        next();
      }
    },
    data() {
      return {
        apply: null,
        model: { settings: null },
        showCreator: false,
        entity: null,
      };
    },
    computed: {
      ...mapGetters(["user", "dict", "permission"]),
      mySys() {
        if (this.user.tenantId == 1) {
          return this.dict.Sys;
        } else {
          return this.dict.MySys;
        }
      },
    },
    mounted() {
      if (this.mySys.length) {
        this.apply = this.mySys[0].code;
        this.changeApply();
      }
    },
    methods: {
      changeApply() {
        let _this = this;
        api.Setting.query({
          sysCode: _this.apply,
          sort: "seqNo",
          asc: true,
        }).then((res) => {
          // res.items.forEach(el => {
          //     if (el.rule) {
          //         el.rule = JSON.parse(el.rule);
          //         if (el.value) {
          //             if (el.rule.type === 'mSel')
          //                 el.value = JSON.parse(el.value);
          //         }
          //     }
          // });
          res.items.forEach((item) => {
            if (item.options) {
              try {
                let ops = JSON.parse(item.options);
                item.optType = ops.type;
                item.optDict = ops.dict;
              } catch (e) {
                item.optType = "text";
                item.optDict = null;
              }
            }
            if (item.rule) {
              item.optRule = JSON.parse(item.rule);
            }
          });
          _this.model.settings = res.items;
        });
      },
      save(item) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            api.Setting.save(item)
              .then((res) => {
                this.$set(item, "id", res.id);
                this.$message.success(`【 ${item.name} 】已保存！`);
              })
              .catch((e) => {
                console.log(e);
                this.$message.error(`【 ${item.name} 】保存失败！`);
              });
          } else {
            return false;
          }
        });
      },
      create() {
        this.entity = { sysCode: this.apply };
        this.showCreator = true;
      },
      del(item) {
        this.$confirm(`确定删除配置项【 ${item.name} 】吗？随意删除可能导致系统运行异常，请谨慎操作！`, "删除确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then((res) => {
          api.Setting.del(item.id);
          this.$nextTick(() => {
            this.changeApply();
          });
        });
      },
    },
  };
</script>
<style scoped>
  .box {
    border: #ebeef5 solid 1px;
    border-left: rgb(217, 236, 255) solid 8px;
    border-radius: 5px;
    background-color: rgb(236, 245, 255);
    padding: 5px;
  }
  .master {
    border: #f5ebeb solid 1px;
    border-left: rgb(255, 234, 217) solid 8px;
    border-radius: 5px;
    background-color: rgb(255, 246, 236);
    padding: 5px;
  }
</style>
